export default "__VITE_ASSET__e5feff03__"